import { useMemo } from 'react'
import { Icon, type IconProps } from '~/components/icon'
import type { ButtonSharedProps } from './button-root'

type ButtonIconProps = Omit<ButtonSharedProps, 'asIconOnly'> & {
  iconColor?: IconProps['color']
  symbol?: IconProps['symbol']
}

export function ButtonIcon({
  variant,
  size,
  disabled,
  iconColor,
  symbol,
}: ButtonIconProps) {
  const sizeToIconSize: Record<
    NonNullable<ButtonSharedProps['size']>,
    IconProps['size']
  > = {
    md: 'extra-small',
    ml: 'small',
    lg: 'small',
    xl: 'small',
  }

  const variantToIconColor: Record<
    NonNullable<ButtonSharedProps['variant']>,
    IconProps['color']
  > = {
    'brand-primary': 'colorTextNeutralInverse',
    'neutral-secondary': 'colorTextNeutralDefault',
    'neutral-tertiary': 'colorTextNeutralDefault',
  }

  const color = useMemo(() => {
    if (disabled) return 'colorTextNeutralDisabled'
    if (iconColor) return iconColor

    return variantToIconColor[variant!]
  }, [disabled, variant])

  const iconSize = sizeToIconSize[size!]

  return <Icon color={color} size={iconSize} symbol={symbol} />
}

ButtonIcon.displayName = 'ButtonIcon'
